<template>
  <div class="content-container">
    <a-form-model ref="searchForm" class="search-form" layout="inline" :model="searchParam">
      <a-form-model-item has-feedback :label="$t('form.common.field.keywords.label')">
        <a-input v-model="searchParam.keywords" :placeholder="$t('form.common.field.keywords.orderHolder')" />
      </a-form-model-item>
      <!-- <a-form-model-item has-feedback :label="$t('form.common.field.state.label')">
        <a-select
          mode="multiple"
          :placeholder="$t('form.common.field.state.message')"
          v-model="searchParam.status"
          :allowClear="true"
          style="width:194px;"
        >
          <a-select-option value="0">{{$t('enum.payStatus.0')}}</a-select-option>
          <a-select-option value="1">{{$t('enum.payStatus.1')}}</a-select-option>
          <a-select-option value="2">{{$t('enum.payStatus.2')}}</a-select-option>
        </a-select>
      </a-form-model-item> -->
      <a-form-model-item>
        <a-button type="primary" html-type="submit" @click="search">{{
          $t(`actionTitles.submit`)
        }}</a-button>
        <a-button :style="{ marginLeft: '15px' }" @click="handleReset">{{
          $t(`actionTitles.clear`)
        }}</a-button>
      </a-form-model-item>
    </a-form-model>

    <div class="table-wrapper">

      <a-table :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleTableChange">
        <a-table-column key="user_name" :title="$t('table.order.thead.user_name')" align="center">
          <template slot-scope="text, record">
            <div>
              <span>{{ record.user_name }}</span>
              <br />
              <span>{{ record.user_phone }}</span>
            </div>
          </template></a-table-column>
        <a-table-column key="order_sn" :title="$t('table.order.thead.order_sn')" data-index="order_sn" align="center" />
        <a-table-column key="amount" :title="$t('table.order.thead.amount')" data-index="amount" align="center" />
        <a-table-column key="order_subject" :title="$t('table.order.thead.order_subject')" data-index="order_subject"
          align="center">
          <template slot-scope="text, record">
            <div>
              <span>{{ record.order_subject }}</span>
              <br />

              <span v-if="record.type == 2">{{ record.extra }}{{ $t('message.orderExtraMessage') }}</span>
              <span v-if="record.type == 3">{{ record.extra }}G</span>
            </div>
          </template>
        </a-table-column>
        <a-table-column key="create_time" :sorter="true" :title="$t('table.order.thead.create_time')"
          data-index="create_time" align="center" />
        <a-table-column key="confirm_time" :sorter="true" :title="$t('table.order.thead.confirm_time')"
          data-index="confirm_time" align="center">
          <template slot-scope="text, record">
            {{ record.confirm_time.indexOf('00:00:00') == -1 ? record.confirm_time : '--' }}
          </template>
        </a-table-column>
        <a-table-column key="status" :title="$t('table.common.thead.status')" data-index="status" align="center">
          <template slot-scope="text, record">
            <!-- <span>{{$t(`enum.payStatus.${record.status}`)}}</span> -->
            <a-icon v-if="record.status == 1" style="color: green" type="check" />
          </template>
        </a-table-column>
        <a-table-column key="pay_type" :title="$t('table.order.thead.pay_type')" data-index="pay_type" align="center">
          <template slot-scope="text, record">
            <span>{{ record.pay_type != '' ? $t(`enum.payType.${record.pay_type}`) : '--' }}</span>
          </template>
        </a-table-column>
        <a-table-column key="operate" :title="$t('table.common.thead.operate')" align="center">
          <template slot-scope="text, record">
            <span class="operate-link" @click="detail(record.id)">{{ $t('actionTitles.detail') }}</span>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>


<script>
import ClearSelected from "../../components/ClearSelected";
import { pageQuery } from "@/api/order";
import { mapState } from "vuex";

export default {
  data() {
    return {
      searchParam: {
        current_page: 1,
        per_page: 10,
        keywords: "",
        status: [],
        order: [],
      },
      data: [],
      loading: false,
      pagination: {
        showQuickJumper: true,
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  components: { ClearSelected },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },
  mounted() {
    this.searchParam.check_type = this.$route.meta.type;
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      let searchParam = {
        ...this.searchParam,
        ...{
          current_page: this.pagination.current,
          per_page: this.pagination.pageSize,
        },
      };
      pageQuery(searchParam)
        .then((res) => {
          if (res.code === 1) {
            this.loading = false;
            this.data = res.data.data;
            this.pagination.total = res.data.total;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination = pagination;
      if (Object.keys(sorter).length > 0) {
        let field = sorter.field;
        let orderStr = sorter.order == "ascend" ? "asc" : "desc";
        let order = {};
        order[field] = orderStr;
        this.searchParam.order = order;
      }
      this.loadData();
    },
    handleReset() {
      this.searchParam = {
        ...{
          current_page: 1,
          per_page: 10,
          keywords: "",
          status: [],
          order: [],
        },
      };
      this.pagination.current = 1;
      this.loadData();
    },
    search() {
      this.reset();
      this.loadData();
    },
    reset() {
      this.pagination.current = 1;
    },
    detail(id) {
      switch (this.userInfo.type) {
        case 1:
          this.$router.push({
            path: '/admin/sys/orderDetail',
            query: { id: id },
          });
          break;
        case 2:
          this.$router.push({
            path: '/member/account/orderDetail',
            query: { id: id },
          });
          break;
        case 3:
          this.$router.push({
            path: '/member/account/orderDetail',
            query: { id: id },
          });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.operate-link {
  color: #0d95e8;
  cursor: pointer;
}

.specialBtn {
  background-color: #7101ad;
  border-color: #7101ad;
}
.specialBtn:hover{
  background-color: #d485ff;
  border-color: #d485ff;
}
.specialBtn:focus{
  background-color: #d485ff;
  border-color: #d485ff;
}
</style>
